import * as React from 'react';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import { Outlet } from 'react-router-dom';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import microServicesPng from "../static/blog_microservices_main_image.png";
import EventBusDesignPatternPng from "../static/eventbus_design_pattern_main_image.png";
import FeatureFlagsPng from "../static/feature_flags_main_image.png";
import testDrivenDevelopmentPng from "../static/blog_test_driven_development_main_image.png";
import compoundComponentsPng from "../static/blog_compound_components_main_image.png";
import solidDesignPrinciplesPng from "../static/blog_solid_principle_main_image.jpeg";

import { Link as RouterLink } from 'react-router-dom';
import Slider from "react-slick";

const settings = {
    dots: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    lazyLoad: true,
    centerMode: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
};

const itemData = [
  {
    img: testDrivenDevelopmentPng,
    title: 'Test Driven Development',
    link: '/blogs/test-driven-development-nodejs',
  },
  {
    img: FeatureFlagsPng,
    title: 'Feature Flags',
    link: '/blogs/feature-flags-and-controlled-rollouts',
  },
  {
    img: EventBusDesignPatternPng,
    title: 'Event Bus Design Pattern',
    link: '/blogs/event-bus-designpattern-nodejs',
  },
  {
    img: microServicesPng,
    title: 'Microservices in Node.JS',
    link: '/blogs/microservices-nodejs',
  },
  {
    img: compoundComponentsPng,
    title: 'Compound Components in React.JS',
    link: '/blogs/compound-components-reactjs',
  },
  {
    img: solidDesignPrinciplesPng,
    title: 'S.O.L.I.D Design Principle in JS',
    link: '/blogs/solid-principles-js',
  },
];


export default function Blog() {
  const scrollToTop = React.useCallback(()=>{
    const termsAndConditionsView = document.getElementById('blogs');
    if (termsAndConditionsView) {
        termsAndConditionsView.scrollIntoView({ behavior: 'smooth' });
    }
  }, []);

  React.useEffect(() => {
    scrollToTop();
  }, []);
  
  return (
    <div>
        <Container id="blogs" sx={{ 
            py: { sm: 16, xs: 12 },
          }} fixed>
          <Typography variant="body1" component="h1" align="center">
             Our featured blog this week
            </Typography>
            <Outlet />
            <Divider sx={{ marginTop: 6, marginBottom: 10}}/>
            <Typography variant="body1" component="h1" align="center">
             Have a read at all our blogs below
            </Typography>
            <br/>
            <Container fixed className='slider-container' sx={{
              px: { sm: 15, xs: 10 },
            }}>
              <Slider {...settings}>
                  {itemData.map((item) => (
                    
                    <RouterLink 
                      to={item.link} 
                      onClick={() => scrollToTop()}
                    >
                      <ImageListItem key={item.img}>
                        <img
                            src={item.img}
                            alt={item.title}
                            loading="lazy"
                            style={{
                              minHeight: '400px',
                              minWidth: '400px',
                              objectFit: 'cover',
                            }}
                          />
                      </ImageListItem>
                      <ImageListItemBar
                          title={item.title}
                          position="below"
                          sx={{
                            textAlign: 'center',
                            textDecoration: 'underline',
                          }}
                        />
                    </RouterLink>
                ))}
              </Slider>
            </Container>
          </Container>
    </div>
  )
}